// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

//
import { Api } from "#/api";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import { Observer } from "mobx-vue";
import {
  Pagination,
  Filter,
  BodyBuilder,
} from "#/common/interfaces/conversionworld/BodyBuilder";

import { OverviewMap } from "./overview_map/OverviewMap";

// Enums
import { BodyBuilderType } from "#/common/enums/conversionworld/BodyBuilder";
import { Headline } from "../../../components/headline/Headline";
import { LoadMoreButton } from "../../../components/load_more_button/LoadMoreButton";
import { throttle } from "../../../common/Utils";
import { BodybuilderList } from "./bodybuilder_list/BodybuilderList";
import { FilterModule } from "../filter_module/FilterModule";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    OverviewMap,
    Headline,
    LoadMoreButton,
    BodybuilderList,
    FilterModule,
  },
})
export class AbhOverviewPageModule extends ModuleBase {
  private query = "";

  private isMapOpen = false;
  private isMapOpenDelayed = false;

  private get vanSolutionHeadline(): string {
    return this.buildHeadline(
      this.instance["van-solution"],
      this.$store.conversionWorld.vanSolutionBodybuilderTotalCount
    );
  }

  private get vanPartnerHeadline(): string {
    return this.buildHeadline(
      this.instance["van-partner"],
      this.$store.conversionWorld.vanPartnerBodybuilderTotalCount
    );
  }

  getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  @Watch("isMapOpen")
  public onIsOpenChanged(newValue) {
    if (newValue) {
      setTimeout(() => {
        this.isMapOpenDelayed = true;
      }, 500);
    } else {
      this.isMapOpenDelayed = false;
    }
  }

  private buildHeadline(o: any, count: number): string {
    let headline = "";

    if (count < 1) return o.headline_empty;
    else if (count === 1) headline = o.headline_singular;
    else headline = o.headline_plural;

    return headline.replace("###COUNT###", "" + count);
  }

  private changeFilter() {
    this.$store.conversionWorldProductFilter.filter.query = this.query;
  }

  private changeFilterThrottled = throttle(this.changeFilter, 750);

  get filterInstance() {
    return {
      mode: "",
      translation: {
        filterButton: this.instance["translation"]["filterButton"],
        compareButton: "",
        allSolution: this.instance["translation"]["allSolution"],
        onlyVanSolution: this.instance["translation"]["onlyVanSolution"],
        onlyVanPartner: this.instance["translation"]["onlyVanPartner"],
        resetFilter: this.instance["translation"]["resetFilter"],
        resetAllFilter: this.instance["translation"]["resetAllFilter"],
        headline_filter: "",
        headline_country: "",
        headline_branche: this.instance["translation"]["headline_branche"],
        headline_aufbauart: "",
        headline_model: "",
        headline_abh: "",
        abh_search_desktop: "",
        abh_search_mobile: "",
        abh_search_van_solution: "",
        show_results: this.instance["translation"]["show_results"],
        count_selected: "",
        refine_model_filter: "",
        refine_antriebsart: "",
        refine_radstand: "",
        refine_gesamtgewicht: "",
        refine_dachart: "",
        refine_kabinenart: "",
      },
    };
  }
}
